export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'Documentos',
    route: 'list-documentos',
    icon: 'FileTextIcon',
  },
  {
    title: 'Cadastros',
    icon: 'PlusSquareIcon',

    children: [
      {
        title: 'Usuários',
        route: 'list-users',

      },
      {
        title: 'Clientes de API',
        route: 'list-clientes_api',

      },
    ]
  },
]
